import React from "react";

const OverlayLoader = ({
  isOpen,
  position = "absolute",
  width = "100%",
  height = "100%",
  top = 0,
  left = 0,
  background = "rgba(255,255,255,0.7)",
  zIndex = 1000,
  ariaLabel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position,
        top,
        left,
        width,
        height,
        background,
        zIndex,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="modern-spinner" aria-label={ariaLabel} />
    </div>
  );
};

export default OverlayLoader;
